import { type ReactElement } from 'react';
import { TicketFormFieldType, type TicketFormField } from '../core/_models';
import TicketAddonField from './TicketAddonField';
import TicketSelectField from './TicketSelectField';
import TicketTextField from './TicketTextField';
import TicketUploadField from './TicketUploadField';
import TicketYesNoField from './TicketYesNoField';

type Props = {
  field: TicketFormField;
  index: number;
};

const TicketFormFieldInput = ({ field, index }: Props): ReactElement => {
  const { label, type, required, help, options = [] } = field;
  const name = `fields.${index}.value`;

  switch (type) {
    case TicketFormFieldType.OPTIONS:
      return <TicketSelectField help={help} label={label} name={name} options={options} required={required} />;
    case TicketFormFieldType.MONEY:
      return (
        <TicketAddonField
          help={help}
          inputMode="decimal"
          label={label}
          name={name}
          placeholder="0,00"
          prefix="R$"
          required={required}
        />
      );
    case TicketFormFieldType.QUANTITY:
      return (
        <TicketAddonField
          help={help}
          inputMode="numeric"
          label={label}
          name={name}
          placeholder="0"
          required={required}
          suffix="un."
        />
      );
    case TicketFormFieldType.DATE:
      return <TicketTextField help={help} label={label} name={name} placeholder="dd/mm/aaaa" required={required} />;
    case TicketFormFieldType.UPLOAD:
      return <TicketUploadField help={help} label={label} name={name} required={required} />;
    case TicketFormFieldType.YES_NO:
      return <TicketYesNoField help={help} label={label} name={name} required={required} />;
  }
};

export default TicketFormFieldInput;
